import Vue from 'vue'
import Vuex from 'vuex' 

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    secretKey: "",
    keysOne: "W8LVmG*b8dnNLI",
    keysEnd:"",
    abilityCome:1,
    // 
    pageNum:0,
  },
  modules: { 
  },
  mutations: {
    setDataFromChild(state, data) {  
      // if(data==0) {
      //   console.log("恢复为0 ---------------------",data);
      // } else {
      //   console.log("更改为",data);
      // }
      state.pageNum = data;
    },
    // setDataPay(state, data) {
    //   console.log("要改的值",state,data);
    //   state.pageNum = data;
    // },
  },
})
